import ClusterIcon from 'components/ClusterIcon';
import ClusterTooltip from 'components/ClusterTooltip';
import FilterCheckboxChip from './FilterCheckboxChip';
import { clusterFilterOptions } from 'utils/filters';
import { handleMixpanelEvent } from '../FilterAccordion/FilterAccordionItem';
import styled from 'styled-components';
import { withMixpanelChange } from 'utils/app';

const risingClusters = clusterFilterOptions.filter(({ value }) => {
    return ['sustained riser', 'seasonal riser', 'rising star'].includes(value);
});

const Wrapper = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.space_6}px;
`;

const GoogleRisingClusterFilterChipsUntracked = ({
    children,
    filters,
    onChange,
    ...props
}) => {
    return (
        <Wrapper {...props}>
            {children}
            {risingClusters.map((option) => {
                const { label, value } = option;
                const checked =
                    !!filters?.cluster &&
                    filters?.cluster.map(({ value }) => value)?.includes(value);

                return (
                    <ClusterTooltip cluster={value} dataSource="google">
                        <FilterCheckboxChip
                            checked={checked}
                            onChange={() =>
                                onChange({
                                    action: checked
                                        ? 'remove-value'
                                        : 'select-option',
                                    option,
                                })
                            }
                            preserveIconSpace={false}
                            key={label}
                        >
                            <ClusterIcon
                                css={`
                                    font-size: ${({ theme }) =>
                                        theme.space_8}px;
                                    margin-right: ${({ theme }) =>
                                        theme.space_5}px;
                                `}
                                cluster={value}
                            />
                            <span>{label}</span>
                        </FilterCheckboxChip>
                    </ClusterTooltip>
                );
            })}
        </Wrapper>
    );
};

const GoogleRisingClusterFilterChipsWithMixpanel = withMixpanelChange(
    GoogleRisingClusterFilterChipsUntracked,
    'GoogleRisingClusterFilterChips',
);

export const GoogleRisingClusterFilterChips = ({
    handleMixpanelEvent: handleMixpanelEventProp = handleMixpanelEvent,
    mixpanelContext = 'GoogleClusterFilterSelect',
    ...props
}) => {
    return (
        <GoogleRisingClusterFilterChipsWithMixpanel
            handleMixpanelEvent={handleMixpanelEventProp}
            mixpanelContext={mixpanelContext}
            {...props}
        />
    );
};

export default GoogleRisingClusterFilterChips;
